import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgPeopleLock = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M12.5 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm0 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM11.5 12a1 1 0 1 1 0 2c-4.443 0-8 3.162-8 7a1 1 0 0 1-2 0c0-4.999 4.502-9 10-9ZM21 15h-7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Zm-1 2v3h-5v-3h5Z" />
      <path d="M17.5 12a2.5 2.5 0 0 1 2.495 2.336L20 14.5V16a1 1 0 0 1-1.993.117L18 16v-1.5a.5.5 0 0 0-.992-.09L17 14.5V16a1 1 0 0 1-1.993.117L15 16v-1.5a2.5 2.5 0 0 1 2.5-2.5Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgPeopleLock)
const Memo = memo(ForwardRef)
export default Memo
